import { TextField as MuiTextField } from '@mui/material';
import { useStore } from '@tanstack/react-form';
import { useFieldContext } from '.';
import { FieldErrors } from './FieldErrors';

type TextFieldProps = {
  label: React.ReactNode;
  hideError?: boolean;
} & React.ComponentProps<typeof MuiTextField>;

export const TextField = (props: TextFieldProps) => {
  const field = useFieldContext<string>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );
  return (
    <MuiTextField
      {...props}
      value={field.state.value}
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      error={
        !props.hideError && (field.state.meta.isTouched || hasTriedToSubmit)
          ? field.state.meta.errors.length > 0
          : false
      }
      helperText={!props.hideError && <FieldErrors meta={field.state.meta} />}
      fullWidth
      label={props.label}
    />
  );
};
